import {
  FETCH_DISTRICTS_REQUEST,
  FETCH_DISTRICTS_SUCCESS,
  FETCH_DISTRICTS_FAILURE,
  FETCH_MUNICIPALITIES_REQUEST,
  FETCH_MUNICIPALITIES_SUCCESS,
  FETCH_MUNICIPALITIES_FAILURE,
} from "../actions/locationActions";

const initialState = {
  districts: [],
  municipalities: [],
  loadingDistricts: false,
  loadingMunicipalities: false,
  error: null,
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DISTRICTS_REQUEST:
      return { ...state, loadingDistricts: true, error: null };
    case FETCH_DISTRICTS_SUCCESS:
      return { ...state, loadingDistricts: false, districts: action.payload };
    case FETCH_DISTRICTS_FAILURE:
      return { ...state, loadingDistricts: false, error: action.payload };

    case FETCH_MUNICIPALITIES_REQUEST:
      return { ...state, loadingMunicipalities: true, error: null };
    case FETCH_MUNICIPALITIES_SUCCESS:
      return { ...state, loadingMunicipalities: false, municipalities: action.payload };
    case FETCH_MUNICIPALITIES_FAILURE:
      return { ...state, loadingMunicipalities: false, error: action.payload };

    default:
      return state;
  }
};

export default locationReducer;
